import { SubjectManager } from "../utils/subject-manager";

export const mmsEventsService = new SubjectManager();
